import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './locales/zh-CN';
import en from './locales/en';
import zhTW from './locales/zh-TW';
import { DEFAULT_LOCALE, isSupportedLocale } from './constants';
import { resolveLocale, saveGuestLocaleToStorage } from './resolve-locale';
import { syncAjaxLanguageHeader } from './ajax-headers';
import { getElementLocaleMessages, syncElementLocale } from './element-locale';

Vue.use(VueI18n);

var initialLocale = resolveLocale();
syncAjaxLanguageHeader(initialLocale);
syncElementLocale(initialLocale);

function mergeMessages(appMessages, elementMessages) {
  return Object.assign({}, elementMessages, appMessages);
}

var i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    'zh-CN': mergeMessages(zhCN, getElementLocaleMessages('zh-CN')),
    en: mergeMessages(en, getElementLocaleMessages('en')),
    'zh-TW': mergeMessages(zhTW, getElementLocaleMessages('zh-TW')),
  },
  silentTranslationWarn: process.env.NODE_ENV === 'production',
});

if (initialLocale) {
  saveGuestLocaleToStorage(initialLocale);
}

export function setAppLocale(locale, options) {
  options = options || {};
  if (!isSupportedLocale(locale)) {
    locale = DEFAULT_LOCALE;
  }
  i18n.locale = locale;
  syncAjaxLanguageHeader(locale);
  syncElementLocale(locale);
  if (options.persistGuest !== false) {
    saveGuestLocaleToStorage(locale);
  }
  if (typeof window !== 'undefined' && window.vbus) {
    window.vbus.$forceUpdate();
  }
}

export default i18n;
